<template>
  <div class="app-container"
       v-if="isShowLoinPage">
    <van-nav-bar title="登录"
                 left-text="退出"
                 @click-left="logOut"
                 left-arrow>
    </van-nav-bar>
    <div class="logo text_c">
      <img src="../../assets/img/login.png"
           alt="">
    </div>
    <van-form class="login_form">
      <div class="border_bottom flex_center_center">
        <img class="icon"
             src="../../assets/icons/phone.svg">
        <van-field v-model="login_params.phone"
                   placeholder="请输入手机号" />
      </div>
      <div class="border_bottom flex_center_between phone_code">
        <div class="flex_center">
          <img class="icon"
               src="../../assets/icons/phone_code.svg">
          <van-field v-model="login_params.code"
                     type="code"
                     maxlength="6"
                     placeholder="请输入验证码" />
        </div>
        <van-button @click="getVerificationCode"
                    size="small"
                    :loading="codeBtnLoading"
                    :disabled="codeBtnDisable">{{codeBtnText}}</van-button>
      </div>
      <div v-if="authType == '2'">
        <div class="border_bottom flex_center_center">
          <img class="icon"
               src="../../assets/icons/username.svg">
          <van-field v-model="parentUserName"
                     maxlength="18"
                     placeholder="请输入学生身份识别号" />
        </div>
      </div>
      <div class="marginTop20">
        <van-button round
                    block
                    @click="onSubmit">登&nbsp;&nbsp;&nbsp;录</van-button>
      </div>

    </van-form>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import {
  getLogin,
  getBindWx,
  getUserRole,
  getLoginWx,
  getVerificationCode,
  getParentFirstLogin
} from '@/api'
export default {
  computed: {
    ...mapGetters(['openId', 'bindOpenId', 'authType'])
  },
  data () {
    return {
      login_params: {
        // phone: '82786609',
        // code: '2'
        phone: '',
        code: ''
      },
      isShowLoinPage: true,
      phoneNum: '',
      codeBtnDisable: false,
      codeBtnText: '获取验证码',
      codeBtnLoading: false,
      parentUserName: ''
    }
  },
  created () {
    this.$store.commit('updateUserInfo', null)
    if (this.openId) {
      if (this.bindOpenId) {
        this.isShowLoinPage = false
        // 使用openId 登录
        this.getLoginWx()
      }
    }
  },
  methods: {
    // 通过openId 登录
    getLoginWx () {
      getLoginWx({
        openId: this.openId,
        authType: this.authType
      })
        .then(res => {
          if (res.code === 200) {
            // 获取用户基本信息
            if (this.authType == 1) {
              this.login_params.phone = res.data.phoneNum
              this.getUserRole()
            } else {
              // 家长
              res.data.code = res.data.employId
              this.$store.commit('updateUserInfo', res.data)
              this.$router.push('/student')
            }

          } else if (res.code === 400 && res.message === '未绑定用户') {
            this.isShowLoinPage = true
          } else {
            this.isShowLoinPage = true
          }
        })
        .catch(err => {
          this.isShowLoinPage = true
        })
    },
    // 获取用户基本信息
    getUserRole () {
      getUserRole({
        phoneNum: this.login_params.phone
      }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.$store.commit('updateUserInfo', res.data)
            // 如果有redirect  就跳转至异常考勤页面
            if (this.$route.query.redirect === 'exception') {
              this.$router.push('/abnormalTemperature')
            } else {
              if (res.data.roleFlag === 'CLASS') {
                // 班级
                this.$router.push('/classTemperature')
              } else if (res.data.roleFlag === 'GRADE') {
                // 年级
                this.$router.push('/gradeTemperature')
              } else {
                // 部门
                this.$router.push('/teacherTemperature')
              }
            }
          }
        }
      })
    },
    logOut () {
      WeixinJSBridge.call('closeWindow')
    },
    // 发送验证码
    getVerificationCode () {
      if (!this.login_params.phone) {
        this.$Toast('请输入手机号')
        return
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}/.test(this.login_params.phone)) {
        this.$Toast('请输入正确的手机号')
        return
      }
      this.codeBtnLoading = true
      getVerificationCode({
        phoneNum: this.login_params.phone
      })
        .then(res => {
          if (res.code === 200) {
            this.$Toast('验证码已发送至您的手机')
            this.codeBtnLoading = false
            this.codeBtnDisable = true
            var time = 60 // 倒计时60秒
            var timer = setInterval(ountDown, 1000) // 设置定时器
            const that = this
            // 倒计时
            function ountDown () {
              time--
              if (time >= 0) {
                that.codeBtnText =
                  time === 0 ? '重新发送' : time + 's后重新发送'
                if (time === 0) {
                  that.codeBtnDisable = false
                }
              } else {
                that.codeBtnTex = '重新发送'
                that.codeBtnDisable = false // 倒计时结束能够重新点击发送的按钮
                clearTimeout(timer) // 清除定时器
                time = 60 // 设置循环重新开始条件
              }
            }
          } else {
            this.codeBtnLoading = false
          }
        })
        .catch(err => {
          this.codeBtnLoading = false
        })
    },
    onSubmit (values) {
      if (!this.login_params.phone || !this.login_params.code) {
        this.$Toast('手机号或者验证码不能为空')
        return
      }
      if (this.authType == 1) {
        getLogin(this.login_params).then(res => {
          if (res.code === 200 && res.data === this.login_params.phone) {
            // 绑定openId  获取用户信息
            getBindWx({
              openId: this.openId,
              phoneNum: this.login_params.phone,
              authType: this.authType
            }).then(bind_res => {
              if (bind_res.code === 200 && bind_res.data === '绑定成功') {
                // 获取用户基本信息
                this.$store.commit('updateBindOpenId', true)
                this.getUserRole()
              }
            })
          }
        })
      } else {
        if (!this.parentUserName) {
          this.$Toast('身份识别号不能为空')
          return
        }
        getParentFirstLogin({
          code: this.login_params.code,
          phoneNum: this.login_params.phone,
          username: this.parentUserName
        }).then(res => {
          if (res.code === 200) {
            this.$store.commit('updateUserInfo', res.data)
            getBindWx({
              openId: this.openId,
              phoneNum: this.login_params.phone,
              authType: this.authType,
              employId: res.data.code,
            }).then(bind_res => {
              if (bind_res.code === 200 && bind_res.data === '绑定成功') {
                this.$store.commit('updateBindOpenId', true)
                this.$router.push('/student')
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.logo {
  padding: 20px 0 30px 0;
  img {
    height: 200px;
    // width: 200px;
  }
}
// ::v-deep .van-nav-bar__content {
//   // background: #cce3ff;
//   .van-nav-bar__title {
//     color: #fff;
//   }
// }
.phone_code {
  /deep/ .van-button {
    word-break: keep-all;
    height: 30px;
    font-size: 12px;
  }
}
// ::v-deep .van-button--small {
//   width: 100px;
//   .van-button__text {
//     display: flex;
//     align-items: center;
//     height: 100%;
//   }
// }
::v-deep .van-nav-bar {
  .van-icon,
  .van-nav-bar__text {
    color: rgb(5, 182, 252);
  }
}
::v-deep .van-button--default {
  background-color: rgb(5, 182, 252);
  color: #fff;
  font-weight: bold;
  font-size: 16px;
}
.login_box {
  background-color: #fff;
}
.login_form {
  width: 100%;
  padding: 0 50px 20px 50px;
  border-radius: 15px;
  background: #fff;
  > div {
    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>